import { Button } from '@nf/ui'
import { matchStyles } from '../match/match.style'
import { AnalyseKey, useConfigsAnalyseAttributeWithToggle } from '@/features/next-analyse';
import { useCurrentProperties } from '@/hooks/query';

interface MoreBetTypesButtonProps {
   moreCount: number;
   clickHandler(): void;
}
export const MoreBetTypesButton = ({
	moreCount,
	clickHandler
}: MoreBetTypesButtonProps) => {
	const { routePrefix } = useCurrentProperties();
	const { getRef } = useConfigsAnalyseAttributeWithToggle([{
		key: 'betslip-toggle',
		activeKey: 'switch-to-single-match-via-my-favorites',
		inactiveKey: 'switch-to-single-match-via-num-btn',
		isActive: routePrefix === 'favorites',
		analyseKey: AnalyseKey.Refined
	}]);

	return (
		<Button 
			variant="icon" 
			className={matchStyles.iconButton}
			onClick={clickHandler}
			ref={getRef('betslip-toggle')}
		>
			{moreCount > 99 ? '99+' : `${moreCount}+`}
		</Button>
	)
}